import {
  WarrantsFilesAccountStatus,
  WarrantsFilesDcaType,
  WarrantsFilesType,
} from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"
import {
  FilterRadio,
  FilterType,
  SoDataTableFilters,
} from "@/types/components/SoDataTable"
import { sentenceCase } from "@/helpers/stringHelpers"

// Build a { value: 'Sentence cased label' } map from a PG-enum-mirroring enum.
const optionsFor = (values: string[]): Record<string, string> =>
  values.reduce(
    (options, value) => {
      options[value] = sentenceCase(value)
      return options
    },
    {} as Record<string, string>,
  )

export const filesStatusOptions = optionsFor(
  Object.values(WarrantsFilesAccountStatus),
)
export const filesTypeOptions = optionsFor(Object.values(WarrantsFilesType))
export const filesDcaTypeOptions = optionsFor(
  Object.values(WarrantsFilesDcaType),
)

export interface WarrantsFilesAccountsTableFilters extends SoDataTableFilters {
  status: FilterRadio<WarrantsFilesAccountStatus>
  fileType: FilterRadio<WarrantsFilesType>
}

export const warrantsFilesAccountsTableFilters: WarrantsFilesAccountsTableFilters =
  {
    status: {
      type: FilterType.RADIO,
      label: "Status",
      value: null,
      options: filesStatusOptions,
      expandable: true,
    },
    fileType: {
      type: FilterType.RADIO,
      label: "File Type",
      value: null,
      options: filesTypeOptions,
      expandable: true,
    },
  }

export interface WarrantsFilesProcessedTableFilters extends SoDataTableFilters {
  fileType: FilterRadio<WarrantsFilesType>
  dcaType: FilterRadio<WarrantsFilesDcaType>
}

export const warrantsFilesProcessedTableFilters: WarrantsFilesProcessedTableFilters =
  {
    fileType: {
      type: FilterType.RADIO,
      label: "File Type",
      value: null,
      options: filesTypeOptions,
      expandable: true,
    },
    dcaType: {
      type: FilterType.RADIO,
      label: "DCA Type",
      value: null,
      options: filesDcaTypeOptions,
      expandable: true,
    },
  }
